import React from 'react';
import { useSelector } from 'react-redux';
import PivotTable from '@/components/PivotTable';
import { getChartingOptions } from '@/store-selectors';
import { SECTION_COLUMN_NAMES } from '@/components/charting/chartingConfiguration.constants';
import { useConfiguredDataTable } from '@/features/queryMetricsDimensionsConfig/metricConfigSlice';
import { useAppSelector } from '@/store/hooks';
import { selectIsLoadingRows } from '@/features/query-builder/queryBuilderSlice';
import { LoadingTimer } from './LoadingTimer';

export const PivotDataPresentation = () => {
  const dataTable = useConfiguredDataTable();
  const isLoading = useAppSelector(selectIsLoadingRows);
  const chartingOptions = useSelector(getChartingOptions);

  if (isLoading || !dataTable) return <LoadingTimer />;

  const getChartOption = (configItem: string[]) => {
    const section = configItem[0];
    const item = configItem[1];
    if (!chartingOptions) {
      return null;
    }
    // @ts-expect-error: TODO: fix.
    const sectionObj = chartingOptions[section] || {};
    const result = sectionObj[item];
    // undefined is used to control default value
    if (result === undefined && configItem.length > 2) {
      return configItem[2];
    }
    return result;
  };

  const getColumnLabel = (heading: any) => {
    const subsection = [SECTION_COLUMN_NAMES, heading.columnName().toString()];
    const value = getChartOption(subsection)
      ? getChartOption(subsection)
      : heading.columnName().name().replace(/\_/g, ' ');
    return value;
  };

  return (
    <PivotTable
      getColumnLabel={getColumnLabel}
      dataTable={dataTable}
      getChartOption={getChartOption}
      // chartContainerHeight={chartContainerHeight}
      identifier={Math.floor(Math.random() * 100)}
    />
  );
};
